  <template
              
            >
              <div v-bar class="vs-scrollable" style="line-height: 2.45; display: flex;">
                <div>
                  <div class="con-exemple-customer-prompt px-4 py-3">
                      <vs-row>
                      <vs-col vs-w="6">
                        <vs-input
                          :danger="errors.selected.firstName"
                          :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Title')})"
                          :label="$t('Service.Table.Title')"
                          v-model="selected.title"
                          class="w-100 mb-2"
                        />
                      </vs-col>
                      <vs-col vs-w="6">
                        <vs-input
                          :danger="errors.selected.description"
                          :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Description')})"
                          :label="$t('Service.Table.Description')"
                          v-model="selected.description"
                          class="w-100 mb-2"
                        />
                      </vs-col>
                      </vs-row>
                    

                <vs-select
            v-if="industries.length>0"
            v-model="selected.industry_id"
            :placeholder="$t('Booking.CreatePrompt.ChooseTargetDepartment')"
            label="Industries"
            class="w-100 mb-3"
          ><vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item,index) in industries"
            />
          </vs-select>

          <vs-select
            v-if="subindustries.length>0"
            v-model="subind"
            placeholder="Subindustries"
            autocomplete
            multiple
            label="Subindustries"
            class="w-100 mb-3"
          ><vs-select-item
              :key="index"
              :value="item.id"
              :text="item.title"
              v-for="(item,index) in subindustries"
            />
          </vs-select>

                    <vs-row>
                      <h3><br> Translations </h3>
                    </vs-row>
                    <vs-row>
                    <vs-input
                          :danger="errors.selected.firstName"
                          :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Title')})"
                          label="en"
                          v-model="selected.translations.en"
                          class="w-100 mb-2"
                        />
                    </vs-row>
                    <vs-row>
                    <vs-input
                          :danger="errors.selected.firstName"
                          :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Title')})"
                          label="fr"
                          v-model="selected.translations.fr"
                          class="w-100 mb-2"
                        />
                    </vs-row>
                    
                    <vs-row>
                        <vs-input
                            :danger="errors.selected.firstName"
                            :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Title')})"
                            label="ar"
                            v-model="selected.translations.ar"
                            class="w-100 mb-2"
                            />
                    </vs-row>

                    <vs-row>
                        <vs-input
                            :danger="errors.selected.firstName"
                            :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Title')})"
                            label="de"
                            v-model="selected.translations.de"
                            class="w-100 mb-2"
                            />
                    </vs-row>

                    <vs-row>
                        <vs-input
                            :danger="errors.selected.firstName"
                            :danger-text="$t('Errors.InvalidPolite', {field: $t('Service.Table.Title')})"
                            label="es"
                            v-model="selected.translations.es"
                            class="w-100 mb-2"
                            />
                    </vs-row>
                    

                    <vs-col vs-w="12" class="text-right mt-4">
                        <vs-button @click="update()" color="primary" class="pr-5 pl-5 float-right"> {{$t('Customer.EditCustomerPrompt.ConfirmButton')}} </vs-button>
                    </vs-col>
                  </div>
                </div>
              </div>
</template>

<script>
import { industryServices, serviceServices } from "../../_services";
export default {
    name:"ViewService",
    data: () => ({
    title: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    industries: [],
    subindustries: [],
    subind:[],
       errors: {
            firstName: false,
            lastName: false,
            email: false,
            phoneNumber: false,
            libID: false,
            selected: {
                firstName: false,
                lastName: false,
                email: false,
                phoneNumber: false,
                libID: false
      }
    },
    }),
    props:{
        selected : Object
    },
    methods:{
        notify(title, text, type) {
        this.$vs.notify({
            color: type,
            title: title,
            text: text
        });
        },
        showLoading() {
        this.$vs.loading({
            container: "#customers-box",
            scale: 0.6
        });
        },
        hideLoading(){
      this.$vs.loading.close('#customers-box > .con-vs-loading')
    },hide(){
      this.$emit('hide', 'hide');
      console.log("bla");
    },
        update(){
            let data = { 
                        description: this.selected.description,
                        industry_id: this.selected.industry_id,
                        subindustry: this.subind,
                        translations: JSON.stringify(this.selected.translations)}
                        this.showLoading();
                        console.log(data);
            serviceServices.update(this.selected.id,data).then(function (data){
                console.log(data);
                this.hide();
                this.notify(
              this.$t("Toasts.Successful"),
              "Service Updated",
              "success"
            );
            }.bind(this))
            .catch(
                
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              "Service Update failed",
              "danger"
            );
          }.bind(this)
        ).finally(function (){
                this.hideLoading();
        }.bind(this))
        }
    },
    mounted(){
        industryServices.getAll().then( function (data) {
            this.industries= data.industries;
        }.bind(this))
        let data = { industry_id : this.selected.industry_id}
        console.log(data);
        industryServices.getsubindustries(data).then( function (data) {
          this.subindustries = data.subindustries;
          console.log(data)
        }.bind(this))
        serviceServices.getById(this.selected.id).then( function (data) {
          console.log(data);
            this.subind= data.service.subindustries;
        }.bind(this))

    }
}
</script>
